import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import {
  PaymentAcceptanceRulesPaymentLinksService,
  PaymentAcceptanceRulesPlatformService,
  PaymentAcceptanceRulesService,
  PaymentAcceptanceRulesGuestCheckoutService,
} from '../services';
import { Injectable } from '@angular/core';

export const paymentAcceptanceRulesServiceFactory = (
  httpClient: HttpClient,
  appConfig: AppConfigSettings,
) => {
  let service: PaymentAcceptanceRulesService;

  if (appConfig.getconfig('usePaymentLinkEndpoints') === 'true') {
    service = new PaymentAcceptanceRulesPaymentLinksService(
      httpClient,
      appConfig,
    );
  } else if (appConfig.getconfig('useHostedPaymentsPageEndpoints') === 'true') {
    service = new PaymentAcceptanceRulesGuestCheckoutService(
      httpClient,
      appConfig,
    );
  } else {
    service = new PaymentAcceptanceRulesPlatformService(httpClient, appConfig);
  }

  return service;
};

@Injectable({
  providedIn: 'root',
})
export class PaymentAcceptanceRulesServiceFactory {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {}

  create(): PaymentAcceptanceRulesService {
    return paymentAcceptanceRulesServiceFactory(
      this.httpClient,
      this.appConfig,
    );
  }
}
